import { Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login/login.component';
import { RoleGuard } from './services/auth/guards/role-guard/role.guard';
import { mobileCalendarGuard } from './services/auth/guards/mobile-calendar/mobile-calendar.guard';
import { canActivateGuard } from './services/auth/guards/canActivate/can-activate.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },

  {
    path: 'admin-calendar',
    loadComponent: () =>
      import('./components/admin/calendar-admin/calendar-admin.component').then(
        (m) => m.CalendarAdminComponent,
      ),
    canActivate: [mobileCalendarGuard, RoleGuard, canActivateGuard],
    data: {
      roles: ['Admin', 'Buero', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
  },
  //{
  //  path: 'admin-calendar/:eventId',
  //  loadComponent: () =>
  //    import('./components/admin/calendar-admin/calendar-admin.component').then(m => m.CalendarAdminComponent),
  //  canActivate: [RoleGuard, canActivateGuard],
  //  data: { roles: ['Admin', 'Buero', 'Personal'] }
  //},
  {
    path: 'admin-calendar/:date',
    loadComponent: () =>
      import('./components/admin/calendar-admin/calendar-admin.component').then(
        (m) => m.CalendarAdminComponent,
      ),
    canActivate: [mobileCalendarGuard, RoleGuard, canActivateGuard],
    data: {
      roles: [
        'Admin',
        'Buero',
        'Personal',
        'Teamleitung',
        'Ausbildung',
        'Praktikant',
      ],
    },
  },
  {
    path: 'blocker-calendar',
    loadComponent: () =>
      import('./components/admin/calendar-blocker/calendar-blocker.component').then(
        (m) => m.CalendarBlockerComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Admin', 'Buero', 'Personal'] },
  },
  {
    path: 'interpreter-calendar',
    loadComponent: () =>
      import('./components/interpreter/calendar-interpreter/calendar-interpreter.component').then(
        (m) => m.CalendarInterpreterComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Admin', 'Dolmetscher', 'Teamleitung', 'Ausbildung'] },
  },
  {
    path: 'Einstellungen',
    loadComponent: () =>
      import('./components/settings/settings.component').then(
        (m) => m.SettingsComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: {
      roles: [
        'Admin',
        'Buero',
        'Personal',
        'Dolmetscher',
        'Teamleitung',
        'Ausbildung',
      ],
    },
  },
  {
    path: 'timesheet',
    loadComponent: () =>
      import('./components/timesheet/timesheet.component').then(
        (m) => m.TimesheetComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: {
      roles: ['Admin', 'Dolmetscher', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
  },
  {
    path: 'annual-overview-admin',
    loadComponent: () =>
      import('./annual-overview-admin/annual-overview-admin.component').then(
        (m) => m.AnnualOverviewAdminComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Admin'] },
  },
  {
    path: 'interpreter',
    loadComponent: () =>
      import('./components/interpreter/calendar-interpreter/calendar-interpreter.component').then(
        (m) => m.CalendarInterpreterComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Admin', 'Dolmetscher', 'Teamleitung', 'Ausbildung'] },
  },
  {
    path: 'termin-filter',
    loadComponent: () =>
      import('./components/filter-view/filter-view/filter-view.component').then(
        (m) => m.FilterViewComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Admin', 'Buero', 'Personal'] },
  },
  {
    path: 'search-event-view/:searchTerm',
    loadComponent: () =>
      import('./components/search-event-view/search-event-view.component').then(
        (m) => m.SearchEventViewComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: {
      roles: ['Admin', 'Buero', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
  },
  {
    path: 'search-advanced-event-view/:searchTerm',
    loadComponent: () =>
      import('./components/search-event-view/search-event-view.component').then(
        (m) => m.SearchEventViewComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: {
      roles: ['Admin', 'Buero', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
  },
  {
    path: 'search-event-view',
    loadComponent: () =>
      import('./components/search-event-view/search-event-view.component').then(
        (m) => m.SearchEventViewComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: {
      roles: ['Admin', 'Buero', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
  },
  {
    path: 'termin-sortierung',
    loadComponent: () =>
      import('./components/sort-event-view/sort-event-view.component').then(
        (m) => m.SortEventViewComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Admin', 'Buero', 'Personal'] },
  },
  {
    path: 'customer-table',
    loadComponent: () =>
      import('./components/crm/customer-table/customer-table.component').then(
        (m) => m.CustomerTableComponent,
      ),
    canActivate: [RoleGuard, canActivateGuard],
    data: {
      roles: ['Admin', 'Buero', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./components/auth/forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent,
      ),
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '**',
    loadComponent: () =>
      import('./components/auth/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
  },
];
